export default __webpack_public_path__ + "static/media/table.8edfecc2.png";